export function getEthereum(window) {
    if (typeof window !== 'undefined') {
        return window.ethereum;
    }
    return undefined;
}
export function fetchEthereum(window) {
    const document = window.document;
    // TODO test with document.readyState !== 'complete' || document.readyState === 'interactive'
    return new Promise((resolve) => {
        const ethereum = getEthereum(window);
        if (ethereum) {
            return resolve(ethereum);
        }
        if (document.readyState !== 'complete') {
            document.onreadystatechange = function () {
                if (document.readyState === 'complete') {
                    document.onreadystatechange = null;
                    resolve(getEthereum(window));
                }
            };
        }
        else {
            resolve(getEthereum(window));
        }
    });
}
export function getVendor(ethereum) {
    if (!ethereum) {
        return undefined;
    }
    else if (ethereum.isRainbow) {
        return 'Rainbow';
    }
    else if (ethereum.isRabby) {
        return 'Rabby';
    }
    else if (ethereum.isFrame) {
        return 'Frame';
    }
    else if (ethereum.isBraveWallet) {
        return 'Brave'; // need to be checked before Metamask as Brave also have `isMetamask`
    }
    else if (ethereum.isMetaMask) {
        return 'Metamask';
    }
    else if (navigator.userAgent.indexOf('Opera') != -1 ||
        navigator.userAgent.indexOf('OPR/') != -1) {
        return 'Opera';
    }
    else {
        return 'unknown';
    }
    // TODO more
}
